<template>
  <div class="page-content">
    <div class="headings d-flex">
      <h2 class="title title-primary">
        {{ $t("lang.admin.print_detail.title") }}
      </h2>
    </div>
    <div class="page-main-content">
      <div class="container-fluid">
        <div class="row">
          <bx-box
            :title="
              $tc('lang.admin.print_detail.tag_number', totalTags, {
                count: totalTags
              })
            "
            color="white"
            no-padding
            :loading="shouldLoading"
            class="col-12"
          >
            <template v-slot:default>
              <skeleton-table :columns="6" v-if="shouldLoading" />
              <bx-table
                :data="data"
                :columns="columns"
                paginated
                v-if="!shouldLoading"
                :currentPage="page"
                :perPage="itemsPerPage"
                backendPagination
                :total="totalTags"
                @update:currentPage="updatePage"
              >
                <template slot-scope="props">
                  <bx-table-column centered class="pt-5">
                    {{ props.row.id }}
                  </bx-table-column>

                  <bx-table-column centered class="pt-5">{{
                    props.row.epc
                  }}</bx-table-column>

                  <bx-table-column centered class="pt-5">
                    {{ props.row.gtin }}
                  </bx-table-column>

                  <bx-table-column centered class="pt-5">
                    {{ props.row.serial_number }}
                  </bx-table-column>
                </template>
              </bx-table>
            </template>
          </bx-box>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from "@/utils/common";

export default {
  name: "PrintOrderDetails",
  mixins: [common],
  data() {
    return {
      shouldLoading: true,
      columns: [],
      data: [],
      totalTags: 0,
      itemsPerPage: process.env.VUE_APP_ITEMS_PER_PAGE,
      page: 1
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    updatePage(p) {
      this.page = p;
      this.getData();
    },
    async getData() {
      try {
        let res = await this.$api.porders.report(this.$route.params.id, {});
        this.data = res;
        this.totalTags = this.data.length;
      } catch (error) {
        console.error(error);
      } finally {
        this.columns = [
          {
            field: "id",
            label: this.$t("lang.admin.print_detail.table.id"),
            centered: true
          },
          {
            field: "epc",
            label: this.$t("lang.admin.print_detail.table.epc"),
            centered: true
          },
          {
            field: "gtin",
            label: this.$t("lang.admin.print_detail.table.gtin"),
            centered: true
          },
          {
            field: "serial",
            label: this.$t("lang.admin.print_detail.table.serial"),
            centered: true
          }
        ];
        this.shouldLoading = false;
      }
    }
  }
};
</script>
